import React from 'react'
import {CreatePaymentMethodData} from '@stripe/stripe-js'
import CreditCardForm, {
  CreditCardFormBaseProps,
  CreditCardFormResult,
} from 'lib/stripe/CreditCardForm'
import {useOptionalBillingTransaction} from 'obvio/Billing/BillingTransactionProvider'

export type SingleUseCreditCardFormProps = CreditCardFormBaseProps & {
  onSuccess: (paymentMethodId: string) => void | Promise<void>
}

export default function SingleUseCreditCardForm(
  props: SingleUseCreditCardFormProps,
) {
  const {onSuccess} = props
  const billingTransaction = useOptionalBillingTransaction()

  const onSubmit = async (result: CreditCardFormResult) => {
    const submit = async () => {
      const {cardElement, name, stripe} = result
      const data: CreatePaymentMethodData = {
        type: 'card',
        card: cardElement,
        billing_details: {
          name,
        },
      }

      const {paymentMethod, error} = await stripe.createPaymentMethod(data)

      if (error) {
        const message = error.message || 'Create Payment Method Error'
        throw new Error(message)
      }

      if (!paymentMethod) {
        throw new Error(
          'Failed to create payment method, you will not be charged. Please contact support.',
        )
      }

      await Promise.resolve(onSuccess(paymentMethod.id))
    }

    if (billingTransaction) {
      await billingTransaction.runTransaction(submit)
      return
    }

    await submit()
  }

  return <CreditCardForm {...props} onSubmit={onSubmit} />
}
